/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, "count, plural, one {": NonNullable<unknown>, s: NonNullable<unknown> }} Context_Menu_Delete_TextInputs */

const en_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.count} event${i?.["count, plural, one {"]} other ${i?.s}}?`)
};

const fr_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etes-vous sur de vouloir supprimer ${i?.count} evenement${i?.["count, plural, one {"]} other ${i?.s}} ?`)
};

const de_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie wirklich das Ereignis ${i?.count}${i?.["count, plural, one {"]} other ${i?.s}} löschen?`)
};

const it_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare l'evento ${i?.count}${i?.["count, plural, one {"]} other ${i?.s}}?`)
};

const ru_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить событие ${i?.count} event${i?.["count, plural, one {"]} other ${i?.s}}?`)
};

const es_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar el evento ${i?.count}${i?.["count, plural, one {"]} other ${i?.s}}?`)
};

const zh_cn2_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除 ${i?.count} 事件 ${i?.["count, plural, one {"]} other ${i?.s}} 吗？`)
};

const ja_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} イベント${i?.["count, plural, one {"]} other ${i?.s}} を削除してもよろしいですか?`)
};

const hi_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई ${i?.count} इवेंट${i?.["count, plural, one {"]} other ${i?.s}} को हटाना चाहते हैं?`)
};

const pt_pt2_context_menu_delete_text = /** @type {(inputs: Context_Menu_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir o evento ${i?.count}${i?.["count, plural, one {"]} other ${i?.s}}?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete {count} event{count, plural, one {} other {s}}?" |
*
* @param {Context_Menu_Delete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete_text = /** @type {((inputs: Context_Menu_Delete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Delete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_delete_text(inputs)
	if (locale === "de") return de_context_menu_delete_text(inputs)
	if (locale === "it") return it_context_menu_delete_text(inputs)
	if (locale === "ru") return ru_context_menu_delete_text(inputs)
	if (locale === "es") return es_context_menu_delete_text(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_delete_text(inputs)
	if (locale === "ja") return ja_context_menu_delete_text(inputs)
	if (locale === "hi") return hi_context_menu_delete_text(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_delete_text(inputs)
	return en_context_menu_delete_text(inputs)
});